import styles from './styles.module.scss';

const AiAnalyticsNumber = ({ number }) => {
  return (
    <div className={styles.aiAnalyticsNumber}>
      {number}
    </div>
  );
};

export default AiAnalyticsNumber;